export const AGENCIES_COUNT_PER_REQUEST = 20;

export enum AGENCIES_SELECT_VALUE_KEYS {
  ID = 'id',
  SHORT_NAME = 'shortName'
}
